import { render, staticRenderFns } from "./PrimitiveTemplateSelector.vue?vue&type=template&id=efd86156&"
import script from "./PrimitiveTemplateSelector.vue?vue&type=script&lang=ts&"
export * from "./PrimitiveTemplateSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
